import { render, staticRenderFns } from "./showDetail.vue?vue&type=template&id=d9daae14&scoped=true&"
import script from "./showDetail.vue?vue&type=script&lang=js&"
export * from "./showDetail.vue?vue&type=script&lang=js&"
import style0 from "./showDetail.vue?vue&type=style&index=0&id=d9daae14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9daae14",
  null
  
)

export default component.exports